import React, { useState, useContext } from 'react';
import { Form, Space, Row, Input, Select } from 'antd';
import { Status } from '../../Status/Status.component';
import { EthernetPorts } from '../../EthernetPorts/EthernetPorts.component';
import { DeviceButtonGroup } from '../DeviceButtonGroup.component';
import { DeleteDeviceModal } from '../../../Modals/DeleteDeviceModal.component.';
import { getDeviceTitle } from '../DevicesList/DevicesList.component';
import { DeleteDeviceButton } from '../DeleteDeviceButton.component';
import { GroupedDevicesTable, SerialNumCell } from '../GroupedDevicesTable.component';
import { PermissionsContext } from '../../../../../router/DashboardRoutes';
import { DeviceRestrictedInput } from '../DeviceRestrictedInput.component';

const { Option } = Select;

export const InDispenserSwitches = ({ data, isPanelPending, saveChanges, renderEditableCellValue, ...props}) => {

    const userPermissions = useContext(PermissionsContext);
    const isPCI = userPermissions.server.pci;

    const [deleteModal, setDeleteModal] = useState({display: false, record: ''});
    const [currentDevice, setCurrentDevice] = useState();

    const deleteDevice = (record) => {
        setDeleteModal({display: true, record: record});
    }

    const vpnModeOptions = [
        {
            value: 0, 
            label: 'Disabled'
        }, 
        {
            value: 1, 
            label: 'Enabled'
        }, 
    ]

    const columns = [
        {
            title: 'Serial Number',
            dataIndex: 'serialNum',
            key: 'serialNum',
            ellipsis: true,
            render: (value, record) => {   
                return (
                    <SerialNumCell panelPending={isPanelPending(record)} value={value}/>
                );
            }
        },
        // {
        //     title: 'Dispenser Name',
        //     dataIndex: 'name',
        //     key: 'name',
        //     width: 200,
        // },
        {
            title: 'Description',
            dataIndex: 'comment',
            key: 'comment',
            ellipsis: true,
            editable: true,
            render: (value, record) => renderEditableCellValue(value, record, 'comment')
        },
        {
            title: 'Ethernet Ports',
            dataIndex: '',
            key: 'ethernetPorts',
            render: (record) => {
                return <EthernetPorts data={record}/>
            }
        },
        {
            title: 'CPU', 
            dataIndex: 'cpu', 
            key: 'cpu', 
            ellipsis: true,
        }, 
        {
            title: 'USB Key ID',
            dataIndex: 'usbKeyID',
            key: 'usbKeyID',
            ellipsis: true,
        },
        {
            title: 'VLANs',
            dataIndex: 'vlanTags',
            key: 'vlanTags',
            ellipsis: true,
        },
        {
            title: 'Version',
            dataIndex: 'version',
            key: 'version',
            ellipsis: true,
        },
        {
            title: 'VPN Mode', 
            dataIndex: 'licensed',
            key: 'licensed',
            ellipsis: true,
            render: (value, record) => {
                const getLabel = (license) => {
                    let mode = vpnModeOptions.find(option => option.value === license);
                    return mode?.label;
                }

                return (
                    <>
                        {getLabel(renderEditableCellValue(value, record, 'licensed'))}
                    </>
                )
            }
        },

        {
            title: 'VPN Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            ellipsis: true,
            render: (status) => {
                return <Status status={status}/>
            }
        },
        {
            title: 'IPs', 
            dataIndex: 'ips', 
            key: 'ips', 
            ellipsis: true,
            render: (_, record) => {
                return (
                    <EthernetPorts data={record} modal={true}/>
                );
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            ellipsis: true,
            render: (value, record) => {
                return (
                    <Row>
                        <Space size="small" onClick={(e) => e.stopPropagation()}>
                            <DeviceButtonGroup serialNum={record.serialNum} status={record.status} ant winbox />
                            <DeleteDeviceButton pending={isPanelPending(record)} onClick={() => deleteDevice(record)} />
                        </Space>
                    </Row>
                );
            },
        },
    ];

    const formItems = (
        <>
            <DeviceRestrictedInput label='Description:' name='comment'  >
                <Input/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='CPU:' name='cpu'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='USB Key ID:' name='usbKeyID'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='VLANs:' name='vlanTags'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <DeviceRestrictedInput label='Version:' name='version'>
                <Input disabled/>
            </DeviceRestrictedInput>
            <Form.Item label='VPN Mode:' name='licensed'>
                <Select>
                    <Option value={0}>OFF</Option>
                    <Option value={1}>ON</Option>
                </Select>
            </Form.Item>
        </>
    );
    
    return (
        <>
            <GroupedDevicesTable
                columns={columns}
                dataSource={data}
                formItems={formItems}
                isPanelPending={isPanelPending}
                saveChanges={saveChanges}
                currentDevice={currentDevice}
                setCurrentDevice={setCurrentDevice}
            />

            { deleteModal.display &&
                <DeleteDeviceModal
                    title={getDeviceTitle(deleteModal.record.deviceType)}
                    item={deleteModal.record} 
                    visible={deleteModal.display} 
                    setVisible={setDeleteModal}
                />
            }
        </>
    );
}